import APIService from "@/services/APIService.js";

export default {
  getAllCalculos(includeExpiredRecords) {
    return APIService.apiCall().get(`/calculoComCaAneel/getAllCalculos/${includeExpiredRecords}`);
  },
  getCalculo(id) {
    return APIService.apiCall().get(`/calculoComCaAneel/getCalculo/${id}`);
  },
  getParametrosEspecificosRacCom(id) {
    return APIService.apiCall().get("/calculoComCaAneel/getParametrosEspecificosRacCom");
  },
  getBensDeInfraestruturaPadrao() {
    return APIService.apiCall().get(`/calculoComCaAneel/getBensDeInfraestruturaPadrao`);
  },
  salvar(id, id_usuario_hexa, postData) {
    return APIService.apiCall().post(`/calculoComCaAneel/salvar/${id}/${id_usuario_hexa}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/calculoComCaAneel/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/calculoComCaAneel/executar/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/calculoComCaAneel/duplicar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/calculoComCaAneel/baixarPlanilha/${id}`, { responseType: "blob", ...config });
  },
  andamento(id) {
    return APIService.apiCall().get(`/calculoComCaAneel/andamento/${id}`);
  },
};
